export default __webpack_public_path__ + "static/media/pranto.02dea47b.jpg";